import { useCallback, useState } from 'react';
import { ProductSpecCode, ProductSpecifications } from '../../../module/types/productSchema';
import IconInfo from './shared/icons/info.svg';

import { Homologation } from './Homologation';
import { LoadIndex } from './LoadIndex';
import { RunFlat } from './RunFlat';
import { SpeedIndex } from './SpeedIndex';
import { Spikes } from './Spikes';
import { TireDiameter } from './TireDiameter';
import { TireProfileHeight } from './TireProfileHeight';
import { TireSeasonality } from './TireSeasonality';
import { TireWidth } from './TireWidth';
import { IsCommercial } from './IsCommercial';
import { BSHM } from './BSHM';

import { CentralHoleDia } from './CentralHoleDia';
import { DepartureET } from './DepartureET';
import { DiscDiameter } from './DiscDiameter';
import { DiscTypes } from './DiscTypes';
import { DiscWidth } from './DiscWidth';
import { MountPCD } from './MountPCD';

import { AkbCapacity } from './AkbCapacity';
import { AkbPolarity } from './AkbPolarity';
import { AkbSize } from './AkbSize';

import { OilViscosity } from './OilViscosity';

type TypeTypeModal = ProductSpecCode | ProductSpecifications;

export const ProductSpecInfoModal = ({ type, className }: { type: TypeTypeModal | string; className?: string }) => {
  const [modal, setModal] = useState<TypeTypeModal | string>('');
  const handlerOpenModal = useCallback(
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      event.preventDefault();
      setModal(prevState => (prevState === type ? '' : type));
    },
    [type],
  );

  const handlerClose = useCallback(() => {
    setModal('');
  }, []);
  return (
    <>
      <IconInfo className={className} onClick={handlerOpenModal} />
      {/* Modal Windows for tire */}
      {[
        ProductSpecCode.Width,
        ProductSpecCode.TruckTyresWidth,
        ProductSpecifications.TyresWidth,
        ProductSpecifications.TruckTyresWidth,
      ].includes(modal as TypeTypeModal) && (
        <TireWidth
          isOpen={[
            ProductSpecCode.Width,
            ProductSpecCode.TruckTyresWidth,
            ProductSpecifications.TyresWidth,
            ProductSpecifications.TruckTyresWidth,
          ].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[
        ProductSpecCode.Height,
        ProductSpecCode.TruckTyresHeight,
        ProductSpecifications.TyresProfile,
        ProductSpecifications.TruckTyresDiameter,
      ].includes(modal as TypeTypeModal) && (
        <TireProfileHeight
          isOpen={[
            ProductSpecCode.Height,
            ProductSpecCode.TruckTyresHeight,
            ProductSpecifications.TyresProfile,
            ProductSpecifications.TruckTyresDiameter,
          ].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[
        ProductSpecCode.Diameter,
        ProductSpecCode.TruckTyresDiam,
        ProductSpecifications.TyresDiameter,
        ProductSpecifications.TruckTyresDiameter,
      ].includes(modal as TypeTypeModal) && (
        <TireDiameter
          isOpen={[
            ProductSpecCode.Diameter,
            ProductSpecCode.TruckTyresDiam,
            ProductSpecifications.TyresDiameter,
            ProductSpecifications.TruckTyresDiameter,
          ].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.Season, ProductSpecifications.TyresSeason].includes(modal as TypeTypeModal) && (
        <TireSeasonality
          isOpen={[ProductSpecCode.Season, ProductSpecifications.TyresSeason].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.Spikes, ProductSpecifications.TyresThorn].includes(modal as TypeTypeModal) && (
        <Spikes
          isOpen={[ProductSpecCode.Spikes, ProductSpecifications.TyresThorn].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.LoadIndex, ProductSpecifications.TyresLoadIndex].includes(modal as TypeTypeModal) && (
        <LoadIndex
          isOpen={[ProductSpecCode.LoadIndex, ProductSpecifications.TyresLoadIndex].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.SpeedIndex, ProductSpecifications.TyresSpeedIndex].includes(modal as TypeTypeModal) && (
        <SpeedIndex
          isOpen={[ProductSpecCode.SpeedIndex, ProductSpecifications.TyresSpeedIndex].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.RunFlat, ProductSpecifications.TyresRunFlat].includes(modal as TypeTypeModal) && (
        <RunFlat
          isOpen={[ProductSpecCode.RunFlat, ProductSpecifications.TyresRunFlat].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.Homologation, ProductSpecifications.TyresHomologation].includes(modal as TypeTypeModal) && (
        <Homologation
          isOpen={[ProductSpecCode.Homologation, ProductSpecifications.TyresHomologation].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}

      {[ProductSpecifications.TyresIsCommercial].includes(modal as ProductSpecifications) && (
        <IsCommercial isOpen={[ProductSpecifications.TyresIsCommercial].includes(modal as ProductSpecifications)} handleClose={handlerClose} />
      )}

      {[ProductSpecifications.TyresBSHM].includes(modal as ProductSpecifications) && (
        <BSHM isOpen={[ProductSpecifications.TyresBSHM].includes(modal as ProductSpecifications)} handleClose={handlerClose} />
      )}

      {/* Modal Windows for disc */}
      {[
        ProductSpecCode.DiskWidth,
        ProductSpecCode.DiskWidthMin,
        ProductSpecCode.DiskWidthMax,
        ProductSpecifications.DiscsWidth,
        ProductSpecifications.MinDiscsWidth,
        ProductSpecifications.MaxDiscsWidth,
      ].includes(modal as TypeTypeModal) && (
        <DiscWidth
          isOpen={[
            ProductSpecCode.DiskWidth,
            ProductSpecCode.DiskWidthMin,
            ProductSpecCode.DiskWidthMax,
            ProductSpecifications.DiscsWidth,
            ProductSpecifications.MinDiscsWidth,
            ProductSpecifications.MaxDiscsWidth,
          ].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.DiskRadius, ProductSpecifications.DiscsDiameter].includes(modal as TypeTypeModal) && (
        <DiscDiameter
          isOpen={[ProductSpecCode.DiskRadius, ProductSpecifications.DiscsDiameter].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.DiskUnitedPcd, ProductSpecifications.DiscsPcd].includes(modal as TypeTypeModal) && (
        <MountPCD
          isOpen={[ProductSpecCode.DiskUnitedPcd, ProductSpecifications.DiscsPcd].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[
        ProductSpecCode.DiskEt,
        ProductSpecCode.DiskEtMin,
        ProductSpecCode.DiskEtMax,
        ProductSpecifications.DiscsEt,
        ProductSpecifications.MinDiscsEt,
        ProductSpecifications.MaxDiscsEt,
      ].includes(modal as TypeTypeModal) && (
        <DepartureET
          isOpen={[
            ProductSpecCode.DiskEt,
            ProductSpecCode.DiskEtMin,
            ProductSpecCode.DiskEtMax,
            ProductSpecifications.DiscsEt,
            ProductSpecifications.MinDiscsEt,
            ProductSpecifications.MaxDiscsEt,
          ].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[
        ProductSpecCode.DiskDia,
        ProductSpecCode.DiskDiaMin,
        ProductSpecCode.DiskDiaMax,
        ProductSpecifications.DiscsDia,
        ProductSpecifications.MinDiscsDia,
        ProductSpecifications.MaxDiscsDia,
      ].includes(modal as TypeTypeModal) && (
        <CentralHoleDia
          isOpen={[
            ProductSpecCode.DiskDia,
            ProductSpecCode.DiskDiaMin,
            ProductSpecCode.DiskDiaMax,
            ProductSpecifications.DiscsDia,
            ProductSpecifications.MinDiscsDia,
            ProductSpecifications.MaxDiscsDia,
          ].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.DiskType, ProductSpecifications.DiscsType].includes(modal as TypeTypeModal) && (
        <DiscTypes
          isOpen={[ProductSpecCode.DiskType, ProductSpecifications.DiscsType].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}

      {/* Modal Windows for akb */}
      {[
        ProductSpecCode.AkbWidth,
        ProductSpecCode.AkbHeight,
        ProductSpecCode.AkbLength,
        ProductSpecCode.AkbSize,
        ProductSpecifications.AkbWidth,
        ProductSpecifications.AkbHeight,
        ProductSpecifications.AkbLength,
        ProductSpecifications.AkbDimensions,
      ].includes(modal as TypeTypeModal) && (
        <AkbSize
          isOpen={[
            ProductSpecCode.AkbWidth,
            ProductSpecCode.AkbHeight,
            ProductSpecCode.AkbLength,
            ProductSpecCode.AkbSize,
            ProductSpecifications.AkbWidth,
            ProductSpecifications.AkbHeight,
            ProductSpecifications.AkbLength,
            ProductSpecifications.AkbDimensions,
          ].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.AkbPolarity, ProductSpecifications.AkbPolarity].includes(modal as TypeTypeModal) && (
        <AkbPolarity
          isOpen={[ProductSpecCode.AkbPolarity, ProductSpecifications.AkbPolarity].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}
      {[ProductSpecCode.AkbCapacity, ProductSpecifications.AkbCapacity].includes(modal as TypeTypeModal) && (
        <AkbCapacity
          isOpen={[ProductSpecCode.AkbCapacity, ProductSpecifications.AkbCapacity].includes(modal as TypeTypeModal)}
          handleClose={handlerClose}
        />
      )}

      {/* Modal Windows for oils */}
      {[ProductSpecifications.OilViscosity].includes(modal as ProductSpecifications) && (
        <OilViscosity isOpen={[ProductSpecifications.OilViscosity].includes(modal as ProductSpecifications)} handleClose={handlerClose} />
      )}
    </>
  );
};
